"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regexEscape = regexEscape;
exports.exact = exact;

var _regex = require("./regex");

function regexEscape(input) {
  const fragment = input.replace(/[$()*+\-.?[\\\]^{|}]/g, m => {
    const digits = m.codePointAt(0).toString(16).padStart(2, '0');
    return `\\x${digits}`;
  });
  return fragment;
}

function exact(input, flags) {
  return (0, _regex.regex)(flags)`${regexEscape(input)}`;
}